import type { FunctionComponent } from 'react';

import { RouterLink } from '@trello/router/router-link';

import type { CardEntity } from './types';

type CardProps = Pick<CardEntity, 'id' | 'shortLink' | 'text'>;

export const Card: FunctionComponent<CardProps> = ({ text, shortLink, id }) => {
  const cardUrl = `/c/${shortLink || id}`;

  return (
    <RouterLink className="action-card" href={cardUrl}>
      {text}
    </RouterLink>
  );
};
